import { render } from "./CustomerService.vue?vue&type=template&id=6adb128a&scoped=true"
const script = {}

import "./CustomerService.vue?vue&type=style&index=0&id=6adb128a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6adb128a"]])

export default __exports__